<!--
 * @Author: your name
 * @Date: 2021-03-24 15:13:16
 ** @LastEditTime: 2025-03-31 13:51:57
 ** @LastEditors: cjhgit jhcuil@outlook.com
 * @Description: In User Settings Edit
 ** @FilePath: \sqm-element\src\components\FactoryTemplate\Sqm\dVmi\check.vue
-->
<template>
  <div class="reportTemplateList">
      <!-- <iframe src="http://10.190.177.156:3030"></iframe> -->
  
          <p class="lable-left">
            <span><i class="el-icon-menu"></i>{{ h_i18n('a6d10d5afe0a1528f8b6c41607894107') }}</span>
            <span style="margin-left: 10%;">{{ h_i18n('3c6447dbf1e28726582b0eee84591631') }}{{patternAmount}}</span>
            <span style="margin-left: 10%;">{{ h_i18n('f08f3f6e2d8c9e579512bb15238b2e43') }}{{BENpatternAmount}}</span>
          </p>
          <div>
              <el-row :gutter="20">
                <el-table @selection-change="handleSelectiontopChange" :loading="loading" ref="topmultipleTable"
                  :data="tableDataone" border size="small" height="200" style="width: 100%" reserve-selection row-key="reportId">
                  <!--  -->
                  <el-table-column reserve-selection type="selection" width="40"></el-table-column>
                  <el-table-column prop="arrivalTime" :label="h_i18n('9c6c1df0e5ab661055353e5efd38c93d')" :formatter="dealDate"></el-table-column>
                  <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')"></el-table-column>
                  <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
                  <!-- <el-table-column prop="batchNo" label="订单号"></el-table-column> -->
                  <el-table-column prop="noteNo" :label="h_i18n('dd63f0153538ad41712bc7655d0a8ded')"></el-table-column>
                  <el-table-column prop="sybName" :label="h_i18n('735aff8652f4ef32793264300a056984')"></el-table-column>
                  <el-table-column prop="associatedNum" :label="h_i18n('181749a2418dccd48f59ef10d3fdf555')"></el-table-column>
              </el-table>
  
              </el-row>
          </div>
          <div>
              <p class="lable-left"><span><i class="el-icon-menu"></i>{{ h_i18n('e97405df555de838f1beb6723f542873') }}</span><span class="lable-left-desc">{{ h_i18n('1c57f258ae82654d9de4c68a427f7c40') }}</span></p>
              <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="search">
                      <div class="searchLable">{{ h_i18n('ef507d473312ee2dbe8c0823008ea6cc') }}</div>
                      <div class="searchContent"> 
                        <el-date-picker @change="dateMapChange('BacthProductDate',searchData.BacthProductDate)" v-model="searchData.BacthProductDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble"/>
                        </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="search">
                      <div class="searchLable">{{ h_i18n('3b321f677ee4b672111b194e0191abf7') }}</div>
                      <div class="searchContent"> 
                        <el-date-picker @change="dateMapChange('CheckDate',searchData.CheckDate)" v-model="searchData.CheckDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble"/>
                        </div>
                    </div>
                  </el-col>
                  <el-col :span="6"><div class="search">
                      <div class="searchLable">{{ h_i18n('2d65236f2c662a5afacbae209774c726') }}</div>
                      <div class="searchContent"><el-input :placeholder="h_i18n('2d65236f2c662a5afacbae209774c726')" v-model="searchData.reportNo" clearable></el-input></div>
                  </div></el-col>
                  <el-col :span="6"><div class="search">
                      <div class="searchLable">{{ h_i18n('f1edca9f040d256cee01ef89fa5499f0') }}</div>
                      <div class="searchContent"><el-input readonly :placeholder="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" v-model="searchData.mtlNo" clearable></el-input></div>
                  </div></el-col>
                  <el-col :span="6"><div class="search">
                      <div class="searchLable">{{ h_i18n('13b062af2976411b3f19c9820febe842') }}</div>
                      <div class="searchContent"><el-input :placeholder="h_i18n('13b062af2976411b3f19c9820febe842')" v-model="searchData.supplyBacth" clearable></el-input></div>
                  </div></el-col>
                  <el-col :span="6"><div class="search">
                      <h-button size="mini" type="primary" @click="handleCurrentChange(1)" style="margin-right: 10px;">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
                      <h-button :loading="loading" size="mini" type="primary" @click="confirmSubmit()">{{ h_i18n('1c3cf7f5f085596674018f3efc645be5') }}</h-button>
                  </div></el-col>
              </el-row>
          </div>
  
      <!-- <el-table @selection-change="handleSelectionbotChange" :loading="loading" ref="multipleTable"
          :data="tableData"  border size="small" height="540" style="width: 100%;min-height: 540px" reserve-selection > -->
          <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" :loading="loading" @selection-change="handleSelectionbotChange"
                 border :data="tableData" size="small" height="540" row-key="reportId"
                style="width: 100%;min-height: 540px">
          <!--  -->
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column prop="reportNo" :label="h_i18n('2d65236f2c662a5afacbae209774c726')" width="150" ></el-table-column>
          <el-table-column prop="bacthProductDate" :label="h_i18n('ef507d473312ee2dbe8c0823008ea6cc')" width="100" :formatter="dealDate" ></el-table-column>
          <el-table-column prop="checkDate" :label="h_i18n('3b321f677ee4b672111b194e0191abf7')" width="100" :formatter="dealDate" ></el-table-column>
          <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="140" ></el-table-column>
          <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200"></el-table-column>
          <el-table-column prop="bacthNum" :label="h_i18n('1c54cb9fcb4ddf8ae7172371e3dcf752')" width="80"></el-table-column>
          <el-table-column prop="associatedNum" :label="h_i18n('3379ba1011dc1a2c4c09fada0c363bdb')" width="100"></el-table-column>
          <el-table-column prop="availableNum" :label="h_i18n('d2acb7556778368993014a226f78ccb4')" width="100"></el-table-column>
          <el-table-column :label="h_i18n('0d21c2ca31a8123e8808d9adbf02eafa')" width="120">
            <template #default="scope">
              <el-input :placeholder="h_i18n('bc60ed037ba2cff52e55ccbf0a69ba81')" v-model="scope.row.associatedNum1" @change="checkjiaofu(scope.row.associatedNum1,scope.row.availableNum)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="supplyBacth" :label="h_i18n('13b062af2976411b3f19c9820febe842')" width="100"></el-table-column>
          <el-table-column prop="bacthLine" :label="h_i18n('767b3bea1695be77ce9c2785ef66ad72')" width="80"></el-table-column>
          <el-table-column prop="shiftProduct" :label="h_i18n('b68919a3b800cc4b543475966a1c5305')" width="80"></el-table-column>
          <el-table-column prop="date120" :label="h_i18n('a5cd4ea1820d5c17c35e86885b1ef10d')" width="80">
              <template #default="scope">
                       <span style="color:blue; cursor: pointer;" @click="goReport(scope.row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="status" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="80">
               <template #default="scope"><span>{{scope.row.status == "1"?h_i18n('f5e626da7e14d2cd3996dcd2627e1c3f'):scope.row.status == "2"?h_i18n('23c1f39900b3af4c3263449782e288e1'):scope.row.status == "3"?h_i18n('32525478cd5c1c93de9c71246021b595'):scope.row.status}}</span></template>
          </el-table-column>
      </el-table>
      <el-pagination background  @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:currentPage="pagenation.currentPage" :page-size="50" layout="total, prev, pager, next,jumper" :total="pagenation.total">
      </el-pagination>
  </div>
  </template>
  
  
  
  <script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  
  import moment from "moment"
  export default {
      name: 'FactoryTemplateSqmVmiCheck',
      data() {
        return {
          tableDataone:[
            {
              requireTime:'',
              mtlNo:'',
              mtlName:'',
              orderNo:'',
              lgort:'',
              sybName:'',
            }
          ],
          jiaobiao:h_i18n('bc60ed037ba2cff52e55ccbf0a69ba81'),
          value:"",
          searchData:{},
          tableData: [],
          pagenation:{
            currentPage:1,
            total:0,
          },
          orderData:{},
          multipleSelection:[],
          loading:false,
          topmultipleSelection:[],
          botmultipleSelection:[],
        }
      },
      computed:{
        patternAmount: function(){
          console.log(this.topmultipleSelection,'topmultipleSelection')
          let sum = 0;
          if(this.topmultipleSelection == '' || this.topmultipleSelection == null || this.topmultipleSelection == undefined){
            return 0
          } else {
            for (let i = 0; i < this.topmultipleSelection.length; i++) {
              console.log(this.topmultipleSelection[i].associatedNum)
              let number = this.topmultipleSelection[i].associatedNum ? Number(this.topmultipleSelection[i].associatedNum):0
              sum = this.AddFloat(sum, number);
            }
            return  this.toFixedFun(sum,3)
          }
        },
        BENpatternAmount: function(){
          console.log(this.tableData,'this.tableData')
          let sum = 0;
          if(this.botmultipleSelection == '' || this.botmultipleSelection == null || this.botmultipleSelection == undefined){
            return 0
          } else {
            for (let i = 0; i < this.botmultipleSelection.length; i++) {
              console.log(this.botmultipleSelection[i].associatedNum1)
              let number = this.botmultipleSelection[i].associatedNum1 ? Number(this.botmultipleSelection[i].associatedNum1):0
              sum = this.AddFloat(sum, number);
            }
            return  this.toFixedFun(sum,3)
          }
        },
        
      },
      methods: {
    h_i18n,
        AddFloat(a1, a2) {
          return (a1 * 10000 + a2 * 10000) / 10000;
        },
        toFixedFun(num,decimal) {
          num = num.toString();
          let index = num.indexOf('.');
          if (index !== -1) {
              num = num.substring(0, decimal + index + 1)
          } else {
              num = num.substring(0)
          }
          return parseFloat(num).toFixed(decimal)
      },
        dateMapChange(item, value) {
            if (value) {
                this.searchData['begin' + item ] = this.time(value[0], 3)
                this.searchData['end' + item ] = this.time(value[1], 3)
            } else {
                this.searchData['begin' + item ] = ""
                this.searchData['end' + item ] = ""
            }
        },
        goReport(row){
          this.$router.push({
                name: "FactoryTemplateSqmInspectDetail",
                query: {
                    name: this.$route.query.name,
                    nickName: this.$route.query.nickName,
                    supplyCode: row.supplyCode,
                    type: 1,//2审核
                    reportId: row.reportId,
                },
            });
        },
        checkjiaofu(a,b){
          for (let i = 0; i < this.botmultipleSelection.length; i++) {
            if(isNaN(Number(this.botmultipleSelection[i].associatedNum1))){
              this.botmultipleSelection[i].jiaofu = true
              this.botmultipleSelection[i].associatedNum1 = ''
              this.$message({
                message: h_i18n('6c45a69ddda20f948520529017f81a35'),
                type: 'error',
                offset :400,
                duration: 1000
              });
            } else {
              this.botmultipleSelection[i].jiaofu = false
            }
          }
          for (var i = 0; i < this.tableData.length; i++) {
            console.log(this.tableData)
            if(this.tableData[i].associatedNum1 > this.tableData[i].availableNum){
              this.tableData[i].associatedNum1 = ''
            }
          }
          console.log(b,'可使用数量')
          if(Number(a) > Number(b)){
            this.info(h_i18n('0a50651c89a00f28b2808371ec3d6e06'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            });
          }
        },
        goTemp(rows){
          this.$router.push({path:"/reportTemplate",query:{
            versionNo:rows.versionNo,
            mtlNo:rows.mtlNo,
            flag:"check",
            dataFrom:this.dataFrom,
            supplyCode:this.$route.query.supplyCode,
          }})
        },
        dealDate(row, column, cellValue, index){ // 处理时间格式
            // console.log("value",row[column.property],column.property)
            return row[column.property]?moment(row[column.property]).format("YYYY-MM-DD"):""
        },
        dealStatus(row, column, cellValue, index){//row, column, cellValue, index
          //(1:暂存；2：HMQM已提交，SQM待完善；3：SQM已提交；4：审核通过；5：驳回）
          let arr = [{key:1,value:h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa')},{key:2,value:h_i18n('cc8c80449d2881be33e3cb6fa935158b')},
          {key:3,value:h_i18n('c82441c9fc62d346cb1b1d91c1c646cf')},{key:4,value:h_i18n('871a30c0993c4e2a71557fe7f38807c0')},{key:5,value:h_i18n('32525478cd5c1c93de9c71246021b595')}]
          let filteList = arr.filter(item=>item.key == row[column.property])
          return filteList.length?filteList[0].value:""
        },
        handleCurrentChange(val) {
          this.pagenation.currentPage = val
          this.getReportLVist();
          console.log(`当1前1页: ${val}`);
        },
        handleSizeChange(val) {
          console.log(`每页 ${val} 条`);
        },
        handleSelectiontopChange(val){
          console.log("handleSelectiontopChange",val)
          if(val.length == 1){
            this.tempBatchNoOf2c1 = val[0].batchNo
            this.tempNoteNoOf2c1 = val[0].noteNo
          }
          this.topmultipleSelection = val;
          console.log(this.topmultipleSelection,'this.topmultipleSelection')
          let sum = 0;
          if(this.topmultipleSelection == '' || this.topmultipleSelection == null || this.topmultipleSelection == undefined){
            return 0
          } else {
            for (let i = 0; i < this.topmultipleSelection.length; i++) {
              console.log(this.topmultipleSelection[i].associatedNum)
              let number = this.topmultipleSelection[i].associatedNum ? Number(this.topmultipleSelection[i].associatedNum):0
              sum = this.AddFloat(sum, number);
            }
            return sum
          }
        },
        handleSelectionbotChange(val){
          console.log("handleSelectionbotChange",val)
          this.botmultipleSelection = val;
          console.log(this.botmultipleSelection,'this.tableData')
          let sum = 0;
          if(this.botmultipleSelection == '' || this.botmultipleSelection == null || this.botmultipleSelection == undefined){
            return 0
          } else {
            for (let i = 0; i < this.botmultipleSelection.length; i++) {
              console.log(this.botmultipleSelection[i].associatedNum1)
              let number = this.botmultipleSelection[i].associatedNum1 ? Number(this.botmultipleSelection[i].associatedNum1):0
              sum = this.AddFloat(sum, number);
            }
            this.BENpatternAmount =  this.toFixedFun(sum,3)
          }
        },
        //unload/item/list
        getReportLVist(){
              let _this = this;
              this.loading = true;
              let paramData={...this.searchData}
              // this.multipleSelections = [...this.multipleSelection]
              if(paramData.endBacthProductDate){
                  paramData.endBacthProductDate = moment(paramData.endBacthProductDate).format("YYYY-MM-DD")
              }
              if(paramData.beginBacthProductDate){
                  paramData.beginBacthProductDate = moment(paramData.beginBacthProductDate).format("YYYY-MM-DD")
              }
              if(paramData.beginCheckDate){
                  paramData.beginCheckDate = moment(paramData.beginCheckDate).format("YYYY-MM-DD")
              }
              if(paramData.endCheckDate){
                  paramData.endCheckDate = moment(paramData.endCheckDate).format("YYYY-MM-DD")
              }
            this.$http({
              method: 'post',
              url: '/base/baseShipmentReport/page',
              // headers: { 'content-type': 'application/x-www-form-urlencoded' },
              data: {
                ...paramData,
                size:50,
                current:this.pagenation.currentPage,
                supplyCode:this.$route.query.supplyCode,
                status:"2",
                checkResult:"合格",availableNumMin:1,},
          }).then((res)=>{
               this.loading = false
              if(res.data.success){
                this.tableData = res.data.data.records
                // this.pagenation.currentPage = res.data.data.size;
                this.pagenation.total = res.data.data.total;
                  //   this.multipleSelection = []
                  console.log(111111,res)
                  // this.$refs.multipleTable.toggleRowSelection(this.multipleSelection);
              }
          });
        },
        confirmSubmit(){
          console.log(this.topmultipleSelection,'topmultipleSelection')
          console.log(this.botmultipleSelection,'botmultipleSelection')
          for (let i = 0; i < this.botmultipleSelection.length; i++) {
            if(this.botmultipleSelection[i].associatedNum1 == ''){
              this.$message({
                message: h_i18n('1f15bb285da2d365d417823bf164954e'),
                type: 'error',
                offset :400,
                duration: 1000
              });
              return false
            }
            if(isNaN(Number(this.botmultipleSelection[i].associatedNum1))){
              this.$message({
                message: h_i18n('eb546c7f530385555a004f382877a007'),
                type: 'error',
                offset :400,
                duration: 1000
              });
              return false
            }
          }
          let length1 = this.topmultipleSelection.length
          let length2 = this.botmultipleSelection.length
          console.log(this.patternAmount,this.BENpatternAmount,'数量统计')
          if(!length1 || length1<1 ){
            this.info(h_i18n('7096cada9c2c2885ee17e8e1a5a5bd44'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            });
            return
          }
          if(!length2 || length2<1 ){
            this.info(h_i18n('f7ad6ba125a7bc3f2cc06ee476e7c168'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            });
            return
          }
          if(Number(this.patternAmount) !== Number(this.BENpatternAmount)){
            
            this.info(h_i18n('49d150f98ce47ef66e5210db367ac6d6'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            });
            return
          }
          // 多订单关联
          if (this.tableDataone.length>1) {
            if(length2 > 1 ){
              this.info(h_i18n('caced1db345976571bfc7892f2be1a66'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              });
              return
            }
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
              message:h_i18n('b281ae24818067b51ad35a22330b7501'),
              callback:(action)=>{
                console.log(action,"----------------------------")
                if(action === "confirm"){
                    this.submit('1')
                }
              }
            })
          } else {
            // 单订单关联
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
              message:h_i18n('78816d0a3798e9fd4c3048ab1ed30855'),
              callback:(action)=>{
                console.log(action,"----------------------------")
                if(action === "confirm"){
                    this.submit('2')
                }
              }
            })
          }
          // this.info({
          //     message:"提交成功",
          //     title: "信息提示",
          //     type:'success',
          //     confirmButtonText: "确定",
          //     // cancelButtonText:"关闭",
          //     callback: (action) => {
          //       if(action === 'confirm'){
          //         this.$router.back()
          //       }
          //     },
          //   });
        },
        submit(a){
          this.loading = true;
          let listReport = [];
          let duobotmultipleSelection = this.botmultipleSelection[0] 
          delete duobotmultipleSelection.patternAmount;
          //多订单关联
          if(a == '1'){
            this.topmultipleSelection.forEach(item=>{
              console.log(duobotmultipleSelection)
              listReport.push(
                {reportId: duobotmultipleSelection.reportId,
                  batchNo :item.batchNo ,
                  associatedNum:item.associatedNum,
                  noteNo:item.noteNo,
                })
            })
          } else {
            //单订单关联 逻辑1个sendGoodsNo
            this.botmultipleSelection.forEach(item=>{
              listReport.push(
                {reportId:item.reportId,associatedNum:item.associatedNum1,
                  batchNo :this.orderData.batchNo? this.orderData.batchNo:this.tempBatchNoOf2c1,
                  noteNo:this.orderData.noteNo? this.orderData.noteNo:this.tempNoteNoOf2c1})
            })
          }
          this.$http({
            method: 'post',
            url: '/base/examinePlanRelationship/addRelationship',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: {
              relationshipInfos:listReport,
                userCode: this.$route.query.supplyCode,
                userName: this.$route.query.nickName,
                name:this.$route.query.name,
                nickName:this.$route.query.nickName
            },
          }).then((res)=>{
            this.loading = false
            if(res.status==200 && res.data.code == '200'){
              this.info({
                title:h_i18n('99c74120cc62f4bf31d661e3212b7121'),
                message:res.data.data,
                type:'success',
                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                callback: (action) => {
                  if(action === 'confirm'){
                    this.$router.back()
                  }
                },
              })
            } else {
              this.info({
                title:h_i18n('99c74120cc62f4bf31d661e3212b7121'),
                message:res.data.data,
                type:'success',
                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                callback: (action) => {
                  if(action === 'confirm'){
                    this.$router.back()
                  }
                },
              })
            }
           
          });
        }
      },
      mounted(){
        console.log(this.$route,'this.$routethis.$route')
        if(this.$route.query.supplyCode){
          this.supplyCode = this.$route.query.supplyCode
        }
        if(this.$route.query.dataFrom){
          this.dataFrom = this.$route.query.dataFrom
        }
        if(this.$route.query.name ||this.$route.query.nickName ){
          // localStorage.setItem("name",this.$route.query.name);
          // localStorage.setItem("nickName",this.$route.query.nickName)
          window.getItemName = this.$route.query.name
          window.getItemNickName = this.$route.query.nickName
        }
        console.log(this.$router,this.$route)
        if(this.$route.query.row){
          let rowList = JSON.parse(this.$route.query.row)
          this.orderData={
              ...rowList
          }
          // 单订单关联
          this.tableDataone[0].arrivalTime = rowList.arrivalTime
          this.tableDataone[0].mtlNo = rowList.mtlNo
          this.tableDataone[0].mtlName = rowList.mtlName
          this.tableDataone[0].batchNo = rowList.batchNo
          this.tableDataone[0].noteNo = rowList.noteNo
          this.tableDataone[0].factoryName = rowList.factoryName
          this.tableDataone[0].sybName = rowList.sybName
          this.tableDataone[0].associatedNum = rowList.associatedNum || 0
          this.patternAmount = this.toFixedFun(rowList.associatedNum,3)
          this.searchData.mtlNo = rowList.mtlNo
          console.log('单订单关联',rowList,this.patternAmount,rowList.associatedNum)
        }
        // 多订单关联
        if(this.$route.query.multipleSelection){
          console.log('多订单关联')
          console.log(this.$route.query.multipleSelection)
          this.tableDataone = JSON.parse(this.$route.query.multipleSelection)
          this.searchData.mtlNo = this.tableDataone[0].mtlNo
          let number = 0
          for (let i = 0; i < this.tableDataone.length; i++) {
            let number1 = Number(this.tableDataone[i].patternAmount)
            number = this.AddFloat(number, number1);
          }
          this.patternAmount =  this.toFixedFun(number,3)
        }
        this.getReportLVist();
        console.log(this.tableDataone,'arryparams')
        this.$nextTick(() => {
           for (let i = 0; i < this.tableDataone.length; i++) {
             this.$refs.topmultipleTable.toggleRowSelection(this.tableDataone[i])
           }
         })
  
      }
  }
  </script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
    .el-table__body td {
    background-color:  #fff ;
  }
  .el-table__body tr:nth-child(odd) td {
     background-color:  #fff ;;
  }
  body .el-table__body tr:nth-child(odd) td {
      background-color: #fff ;
    
  }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #E2F2FF !important;
    // background-color: #e7eeff !important;
     
  }
  .el-table th {
    padding: 8px 0;
    font-size: 14px !important;
    color: #1D2129;
    background: #DDEDFE !important;
  }
//   .el-table tr td {
//     background-color: #fff !important;
//     padding: 8px 0;}
//     .el-table tr:nth-child(odd) td {
//     background-color: #fafafa !important;
// }
    span.jiaobiao {
        position: absolute;
        width: 110px;
        height: 30px;
        line-height: 30px;
        background: #fff;
        color: red;
        z-index: 999;
        margin-left: 105px;
        border-radius: 5px;
        box-shadow: 2px 4px 8px #ddd;
    }
    .reportTemplateList{
      width: 1150px;
      margin: 0px auto;
      height: auto;
      overflow: visible;
      background: white;
      font-size: 12px;
      padding: 10px;
      .searchLable{
        width: 85px !important;
      }
      .searchContent{
        width: calc(100% - 90px) !important; 
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
      }
      .lable-left{
        margin-top: 0px;
        padding-right: 20px;
        border-bottom: 1px solid #E5E6E7;
        span{
            font-size: 1.5em;
            line-height: 33px;
            color: #333;
        }
        .lable-left-desc{
            font-size: 14px;
            color: red;
        }
        i{
            color: #387CD7;
            padding-right: 10px;
        }
      }
    }
  </style>